import './sentry';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import createRouter from './Router';
import './index.css';
import { ParallaxProvider } from 'react-scroll-parallax';
import { EhrIntegrationSettingsProvider } from '@/common/contexts';

const rootElement = createRoot(document.getElementById('root')!);
rootElement.render(
  <EhrIntegrationSettingsProvider>
    <ParallaxProvider>
      <StrictMode>
        <RouterProvider router={createRouter()} />
      </StrictMode>
    </ParallaxProvider>
  </EhrIntegrationSettingsProvider>
);
